import { buildRequest } from '.';

class dashboard {
  configuration = () => (
    buildRequest('GET', '/system/configuration-metrics')
  )

  monitoring = () => (
    buildRequest('GET', '/system/monitoring-metrics')
  )
}

export default dashboard;
